import { render, staticRenderFns } from "./invoice-dashboard-card.vue?vue&type=template&id=79474c4b&scoped=true&"
import script from "./invoice-dashboard-card.vue?vue&type=script&lang=js&"
export * from "./invoice-dashboard-card.vue?vue&type=script&lang=js&"
import style0 from "./invoice-dashboard-card.vue?vue&type=style&index=0&id=79474c4b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79474c4b",
  null
  
)

export default component.exports